import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { addCmsQuery, fetchCmsByTypeQuery, updateCmsQuery } from "../../api/cmsApi";

// Async Thunks for CMS operations

// Fetch CMS by type
export const getCmsByType = createAsyncThunk(
  "cms/getCmsByType",
  async ({type,lan}: {type: 'privacy_policy' | 'terms_and_conditions';lan:string} , { dispatch, rejectWithValue }) => {
    dispatch(resetCmsStatus());

    try {
      return await fetchCmsByTypeQuery(type,lan);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Create a new CMS entry
export const createCms = createAsyncThunk(
  "cms/createCms",
  async (newCms: { type: 'privacy_policy' | 'terms_and_conditions'; content: string; lan:string}, { dispatch, rejectWithValue }) => {
    dispatch(resetCmsStatus());

    try {
      return await addCmsQuery(newCms);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Update an existing CMS entry
export const updateCmsEntry = createAsyncThunk(
  "cms/updateCmsEntry",
  async ({ type, content ,lan}: { type: 'privacy_policy' | 'terms_and_conditions'; content: string;lan:string }, { dispatch, rejectWithValue }) => {
    dispatch(resetCmsStatus());

    try {
      return await updateCmsQuery(type, { content },lan);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// CMS Slice

const cmsSlice = createSlice({
  name: "cms",
  initialState: {
    cms: null as any | null,
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetCmsStatus(state) {
      state.status = null;
      state.msg = "";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch CMS by type
      .addCase(getCmsByType.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.cms = action.payload;
      })
      .addCase(getCmsByType.rejected, (state, action) => {
        state.status = false;
        state.cms = null;
        state.error = action.payload as string;
      })

      // Create CMS entry
      .addCase(createCms.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.cms = action.payload;
        state.msg = "CMS entry created successfully.";
      })
      .addCase(createCms.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Update CMS entry
      .addCase(updateCmsEntry.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.cms = action.payload;
        state.msg = "CMS entry updated successfully.";
      })
      .addCase(updateCmsEntry.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetCmsStatus } = cmsSlice.actions;
export default cmsSlice.reducer;
